import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonIcon, IonImg, useIonAlert,
} from '@ionic/react';
import {
    chevronBack,
    chevronForward, eye, trash,
} from 'ionicons/icons';
import useStore from "../../zustand/useStore";
import {
    actionToApproveJobPortalJobPost, actionToApproveMatrimonialPostData,
    actionToDeleteMatrimonialPostData,
    actionToGetAdminMatrimonialPostingByFilter,
} from "../../apiHelpers/CommonAction";
import {FacebookLoader} from "../../components/Loader/FacebookLoader";
import MatrimonialDetailSheetPopup from "../../components/MatrimonialDetailSheetPopup";

const ITEMS_PER_PAGE = 10;

const AdminMatrimonialPage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [matrimonialProfileDetail, setMatrimonialProfileDetail] = useState(1);
    const {matrimonialPostingState} = useStore();
    const {loading,profiles,totalCount} = matrimonialPostingState;
    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);
    const [presentAlert] = useIonAlert();
    const [isDetailOpen, setIsDetailOpen] = useState(false);

    const callFunctionToDeletedata = (id,userId)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteMatrimonialPostData(id,userId)
                    }},
            ],
        });
    }

    const openPostDetailPanel = (data)=>{
        setMatrimonialProfileDetail(data)
        setIsDetailOpen(true);
    }

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);
        actionToGetAdminMatrimonialPostingByFilter(false, { offset: newOffset });
    }, []);

    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const callFunctionToApproveProfilePost = (id,user_email)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to approve this profile.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Approve', role: 'confirm', handler: async () =>{
                        await actionToApproveMatrimonialPostData(id,user_email)
                        fetchPageData(currentPage);
                    }},
            ],
        });
    }

    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <h2 className="newsletter-heading">All Matrimonial Profiles</h2>
                    </div>

                    <div className="newsletter-table-container">
                        <table className="newsletter-table material-profiles-datatable">
                            <thead>
                            <tr>
                                <th>Profile</th>
                                <th>Name</th>
                                <th>Religion</th>
                                <th>Occupation</th>
                                <th>Created At</th>
                                <th>Created By</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {(loading) ?
                                <>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                        <td>
                                            <FacebookLoader type={"facebookStyle"} item={1}/>
                                        </td>
                                    </tr>
                                </>
                                :(profiles?.length > 0) ? (
                                    profiles.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                               <IonImg
                                                    src={
                                                        (Array.isArray(item.image_url)
                                                                ? item.image_url
                                                                : JSON.parse(item.image_url || "[]")
                                                        )[0]
                                                    }
                                                    alt={item.name}
                                                    className="newsletter-img"
                                                />
                                            </td>
                                            <td>{item.name}</td>
                                            <td>{item.religion}</td>
                                            <td>{item.occupation}</td>
                                            <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                            <td>{item.created_by}</td>
                                            <td>
                                                {(!item?.is_approved) ?
                                                    <div onClick={() => callFunctionToApproveProfilePost(item?.id,item?.email)}
                                                         className="filter_sheet_clear_all_btn approve">
                                                        Not Approved
                                                    </div>
                                                    :
                                                    <div className="filter_sheet_clear_all_btn approved">
                                                        Approved
                                                    </div>
                                                }
                                            </td>
                                            <td className={"action_td"}>
                                                <IonIcon icon={eye} onClick={()=>openPostDetailPanel(item)} className={"admin_delete_button_icon eye_icon"}/>
                                                <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id,item?.created_by)} className={"admin_delete_button_icon"}/>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center' }}>
                                            No matrimonial data found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>
            <MatrimonialDetailSheetPopup
                isOpen={isDetailOpen}
                onDidDismiss={() => setIsDetailOpen(false)}
                matrimonialProfileDetail={matrimonialProfileDetail}/>
        </IonPage>
    );
};

export default AdminMatrimonialPage;
